import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaPhone, FaList, FaPlug, FaGift, FaBug, FaSignOutAlt } from 'react-icons/fa';

const Header = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        sessionStorage.removeItem('isLoggedIn');
        sessionStorage.removeItem('user');
        navigate('/');
    };


    return (
        <header className="bg-light d-flex justify-content-between align-items-center px-3 py-2 shadow-sm">
            {/* <h5 className="m-0">eMedha Chatbot Services</h5> */}
            {/* <div>
                <Dropdown align="end" autoClose="outside" drop="down">
                    <Dropdown.Toggle variant="outline-secondary" size="sm" id="profile-dropdown">
                        Profile
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item
                            href="/profile"
                            style={{ textDecoration: 'none', color: 'black' }}
                            onMouseEnter={(e) => e.target.style = { ...{ textDecoration: 'none', color: 'black' }, ...{ backgroundColor: '#075E54', color: 'white' } }}
                            onMouseLeave={(e) => e.target.style = { textDecoration: 'none', color: 'black' }}
                        >
                            <FaUser className="me-2" /> My Account
                        </Dropdown.Item>
                        <Dropdown.Item
                            href="#"
                            style={{ textDecoration: 'none', color: 'black' }}
                            onMouseEnter={(e) => e.target.style = { ...{ textDecoration: 'none', color: 'black' }, ...{ backgroundColor: '#075E54', color: 'white' } }}
                            onMouseLeave={(e) => e.target.style = { textDecoration: 'none', color: 'black' }}
                        >
                            <FaPhone className="me-2" /> WhatsApp Numbers
                        </Dropdown.Item>
                        {/* <Dropdown.Item
                            href="#"
                            style={{ textDecoration: 'none', color: 'black' }}
                            onMouseEnter={(e) => e.target.style = { ...{ textDecoration: 'none', color: 'black' }, ...{ backgroundColor: '#075E54', color: 'white' } }}
                            onMouseLeave={(e) => e.target.style = { textDecoration: 'none', color: 'black' }}
                        >
                            <FaList className="me-2" /> My Subscriptions
                        </Dropdown.Item>
                        <Dropdown.Item
                            href="#"
                            style={{ textDecoration: 'none', color: 'black' }}
                            onMouseEnter={(e) => e.target.style = { ...{ textDecoration: 'none', color: 'black' }, ...{ backgroundColor: '#075E54', color: 'white' } }}
                            onMouseLeave={(e) => e.target.style = { textDecoration: 'none', color: 'black' }}
                        >
                            <FaPlug className="me-2" /> Integrations
                        </Dropdown.Item>
                        <Dropdown.Item
                            href="#"
                            style={{ textDecoration: 'none', color: 'black' }}
                            onMouseEnter={(e) => e.target.style = { ...{ textDecoration: 'none', color: 'black' }, ...{ backgroundColor: '#075E54', color: 'white' } }}
                            onMouseLeave={(e) => e.target.style = { textDecoration: 'none', color: 'black' }}
                        >
                            <FaGift className="me-2" /> Refer and Earn
                        </Dropdown.Item> *
                        <Dropdown.Item
                            href="/reportbug"
                            style={{ textDecoration: 'none', color: 'black' }}
                            onMouseEnter={(e) => e.target.style = { ...{ textDecoration: 'none', color: 'black' }, ...{ backgroundColor: '#075E54', color: 'white' } }}
                            onMouseLeave={(e) => e.target.style = { textDecoration: 'none', color: 'black' }}
                        >
                            <FaBug className="me-2" /> Report Bug
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item
                            onClick={handleLogout}
                            style={{ textDecoration: 'none', color: 'black' }}
                            onMouseEnter={(e) => e.target.style = { ...{ textDecoration: 'none', color: 'black' }, ...{ backgroundColor: '#075E54', color: 'white' } }}
                            onMouseLeave={(e) => e.target.style = { textDecoration: 'none', color: 'black' }}
                        >
                            <FaSignOutAlt className="me-2" /> Log Out
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div> */}
        </header>
    );
};

export default Header;
